import React, { useState, useEffect } from 'react';
import { Languages } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useSiteMetadata } from '@/hooks/use-site-metadata';

export default function LangSelector() {
  const [currentPath, setCurrentPath] = useState('');
  const { siteUrl } = useSiteMetadata();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentPath(window.location.pathname);
    }
  }, []);

  // Visit the link below to translate the page and update the generateLangUrl link
  // https://translate.google.com/?sl=auto&tl=en&op=websites
  const generateLangUrl = (languageCode) => `https://vasculitis--melbourne2026-com.translate.goog${currentPath}?_x_tr_sl=auto&_x_tr_tl=${languageCode}&_x_tr_hl=en&_x_tr_pto=wapp`;

  const originalUrl = siteUrl;

  // Add / remove languages
  const english = "en";
  const bahasa = "id";
  const chinese = "zh-CN";
  const japanese = "ja";
  const korean = "ko";
  const french = "fr";
  const spanish = "es";
  const hindi = "hi";
  const german = "de";
  const portuguese = "pt";

  const handleLanguageChange = (languageCode) => {
    if (languageCode === english) {
      window.location.href = `${originalUrl}${currentPath}`;
    } else {
      window.location.href = generateLangUrl(languageCode);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="bg-gradient-to-r from-c1 to-c3 text-white rounded-full p-2" aria-label="Language selection">
        <Languages />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel className="text-dbrown">Languages</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(english)} className="cursor-pointer">
          English
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(bahasa)} className="cursor-pointer">
          Bahasa
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(chinese)} className="cursor-pointer">
          中文
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(japanese)} className="cursor-pointer">
          日本語
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(korean)} className="cursor-pointer">
          한국어
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(french)} className="cursor-pointer">
          Français
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(spanish)} className="cursor-pointer">
          Español
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(hindi)} className="cursor-pointer">
          हिन्दी
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(german)} className="cursor-pointer">
          Deutsch
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => handleLanguageChange(portuguese)} className="cursor-pointer">
          Português
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
